import { render, staticRenderFns } from "./ListInsights.vue?vue&type=template&id=b5cae6a2"
import script from "./ListInsights.vue?vue&type=script&lang=js"
export * from "./ListInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cae6a2')) {
      api.createRecord('b5cae6a2', component.options)
    } else {
      api.reload('b5cae6a2', component.options)
    }
    module.hot.accept("./ListInsights.vue?vue&type=template&id=b5cae6a2", function () {
      api.rerender('b5cae6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ListInsights.vue"
export default component.exports